<template>
    <div class="auto-field">
        <div class="auto-field__heading">
            <h3
                v-if="showHeading && !fieldIsCheckbox"
                :class="headingClass"
            >
                {{ fieldLabel }}
            </h3>

            <input-tip class="input-tip" v-if="field.tip && !fieldIsCheckbox" :tip="field.tip" />
        </div>

<!--        <i v-if="readonly && field.required && !field.value">Информация отсутствует</i>-->
        <checkbox-group
                v-if="fieldIsCheckboxesList"
                @input="emitInput"
                @change="emitChange"
                :required="required"
                :value="field.value"
                :options="field.possibleValues"
                :error="error"
                :readonly="readonly"
        />
        <checkbox
                v-else-if="fieldIsCheckbox"
                @input="emitInput"
                @change="emitChange"
                :required="required"
                :value="field.value"
                :label="field.label"
                :error="error"
                :tip="field.tip"
                :readonly="readonly"
        />
        <text-input
                v-else-if="fieldIsTextBox"
                @input="emitInput"
                @change="emitChange"
                :required="required"
                :value="field.value"
                :input-id="field.key"
                :input-value-type="field.type"
                :error="error"
                :readonly="readonly"
        />
        <file-input
                v-else-if="fieldIsFile"
                @input="emitInput"
                @change="emitChange"
                :required="required"
                :value="field.value"
                :input-id="field.key"
                :readonly="readonly"
        />
        <file-preview
                v-else-if="fieldIsFilePreview"
                :file="field.value"
        />
        <v-select
                v-else-if="fieldIsSelect"
                :options="field.possibleValues"
                :required="required"
                @input="emitInput"
                @change="emitChange"
                :error="error"
                :readonly="readonly"
                :value="field.value"
        />
        <date-input
            v-else-if="fieldIsDatePicker"
            @input="emitInput"
            @change="emitChange"
            :required="required"
            :value="field.value"
            :error="error"
            :readonly="readonly"
        />
    </div>
</template>

<script>
import Checkbox from './Checkbox'
import CheckboxGroup from './CheckboxGroup'
import FileInput from './FileInput'
import FilePreview from "./FilePreview";
import vSelect from './vSelect'
import TextInput from './TextInput'
import DateInput from './DateInput'
import InputTip from './InputTip'

export default {
  name: 'AutoField',
  props: {
    field: {
      required: true
    },
    value: {
      required: false
    },
    showHeading: {
      type: Boolean,
      default: true
    },
    headingClass: {
      type: String,
      required: false
    },
    required: {
      type: Boolean,
      default: false
    },
    error: {
        type: Boolean,
        default: false
    },
    readonly: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  components: { Checkbox, CheckboxGroup, FileInput, vSelect, TextInput, DateInput, InputTip, FilePreview },
  computed: {
    fieldIsCheckboxesList() {
      return this.field.type === 'checkbox' && this.field.possibleValues !== undefined
    },
    fieldIsCheckbox() {
      return this.field.type === 'checkbox' && this.field.possibleValues === undefined
    },
    fieldIsTextBox() {
      return (this.field.type === 'string' || this.field.type === 'number') && this.field.possibleValues === undefined
    },
    fieldIsSelect() {
      return (this.field.type === 'string' || this.field.type === 'number') && this.field.possibleValues !== undefined
    },
    fieldIsFile() {
      return this.field.type === 'file'
    },
    fieldIsFilePreview() {
      return this.field.type === 'file-preview'
    },
    fieldIsDatePicker() {
      return this.field.type === 'date'
    },
    fieldLabel() {
      return this.field.label + (this.required ? '*' : '')
    }
  },
  methods: {
    emitInput(value) {
      this.$emit('input', value)
    },
    emitChange(value) {
      this.$emit('change', value)
    }
  },
}
</script>

<style lang="sass" scoped>
    .auto-field__heading
        display: flex
        width: 100%
        align-items: flex-start

    .input-tip
        margin-top: gridSteps(0.5)
        margin-left: gridSteps(1)
</style>
